import * as React from "react"
import { useTheme } from "@mui/material/styles"
import { createGlobalStyle } from "styled-components"

export const html = {
  WebkitFontSmoothing: "antialiased", // Antialiasing.
  MozOsxFontSmoothing: "grayscale", // Antialiasing.
  // Change from `box-sizing: content-box` so that `width`
  // is not affected by `padding` or `border`.
  boxSizing: "border-box"
}
// TODO: dark and light background images
export const body = (theme) => {
  return {
    color: theme.palette.text.primary,
    ...theme.typography.body2,
    backgroundColor: theme.palette.background.default,
    background: theme.palette.background.default,
    "@media print": {
      // Save printer ink.
      backgroundColor: theme.palette.common.white
    }
  }
}

export const styles = theme => ({
  "@global": {
    html,
    "*, *::before, *::after": {
      boxSizing: "inherit"
    },
    "strong, b": {
      fontWeight: theme.typography.fontWeightBold
    },
    body: {
      margin: 0, // Remove the margin in all browsers.
      ...body(theme),
      // Add support for document.body.requestFullScreen().
      // Other elements, if background transparent, are not supported.
      "&::backdrop": {
        backgroundColor: theme.palette.background.default
      }
    }
  }
})

/**
 * Kickstart an elegant, consistent, and simple baseline to build upon.
 */
function CssBaseline(props) {
  /* eslint-disable no-unused-vars */
  const { children = null, classes } = props
  const theme = useTheme()

  const BaseStyles = createGlobalStyle`
    html {
      -webkit-font-smoothing: antialiased;
      -moz-osx-font-smoothing: grayscale;
      box-sizing: border-box;
    }
    body {
      margin: 0;
      color: ${theme.palette.text.primary};
      background: ${theme.palette.background.default};
      font-family: ${theme.typography.body2.fontFamily};
      font-size: ${theme.typography.body2.fontSize};
      font-weight: ${theme.typography.body2.fontWeight};
      line-height: ${theme.typography.body2.lineHeight};
    }
    body::backdrop {
      background-color: ${theme.palette.background.default};
    }
    *, *::before, *::after {
      box-sizing: inherit;
    }
    strong, b {
      font-weight: ${theme.typography.fontWeightBold};
    }
  `

  // todo - add react viz styles in here

  /* eslint-enable no-unused-vars */
  return (
    <React.Fragment>
      <BaseStyles />
      {children}
    </React.Fragment>
  )
}

export default CssBaseline
